export default {
  title: {
    step1Request: 'Solicitud',
    step1Identity: 'Identificación',
    step2: 'Riesgo',
    step3: 'Resultado Riesgo',
    step4: 'Resumen',
    step5Ok: 'Terminado',
    step5Ko: 'Proceso interrumpido',
    step5StripeRetry: 'Nueva tarjeta',
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal',
    login: 'Identificación',
    'onboarding-login': 'Idetificación Prospecto',
    'onboarding-upload-documentation': 'Subida documentación',
    'onboarding-thanks': 'Gracias'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos',
      moreInfo: 'Más información',
      messageCongratulations: '"Enhorabuena" Tu solicitud ha sido aprobada. ',
      textReference: 'Referencia de operación Ayvens:'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnContinue: 'Continuar',
      messageSend: 'Enviando...',
      btnAcceptContinue: 'Aceptar y continuar',
      btnIsCompany: 'Soy una empresa',
      btnAcceptAndContinue: 'Aceptar y continuar',
      btnAcceptAndRecord: 'Aceptar y Grabar'
    },
    label: {
      driverLicense: 'Permiso de conducción',
      renovation: 'Renovación',
      renovationExplanation: ' (en caso de tener un coche con Ayvens que vayas a devolver)',
      plateNumber: 'Matricula',
      personalData: 'Datos personales',
      companyData: 'Datos de empresa',
      contactData: 'Datos de contacto',
      about: 'Sobre tí',
      reserved: 'Reservado',
      error: 'Error',
      company: 'Empresas',
      step1: 'PASO 1',
      step1Ext: 'Identificación',
      step2: 'PASO 2',
      step2Ext: 'Información del cliente',
      step3: 'PASO 3',
      step3Ext: 'Información adicional',
      step4: 'PASO 4',
      step4Ext: 'Información adicional del cliente',
      accordionIdentity: 'Confirma tu identidad',
      accordionProcess: 'Confirma tu identidad',
      allDataRequired: 'Todos los datos son obligatorios',
      soleAdministratorQuestion1:
        '¿Es administrador único de la compañía y dispone de Certificado Digital de representante de administrador único de la misma?',
      soleAdministratorQuestion2:
        '¿Dispone de Certificado Digital de representante de administrador único de la misma?'
    },
    placeholder: {
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      name: 'Nombre',
      surname: 'Primer apellido',
      surname2: 'Segundo apellido',
      documentTypes: 'Tipo de documento',
      documentId: 'Nº Documento (DNI, NIE)',
      cif: 'CIF',
      nif: '/NIF',
      fax: 'Fax',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      issueDate: 'Fecha de emisión',
      operationOwner: 'Operacion de',
      marketPlaceOrderId: 'Referencia interna',
      documentsData: 'Documentos',
      showMessagesModalTitle: 'Error',
      showMessagesModalOnboardingTitle: 'IMPORTANTE',
      showFiles: 'Ver documentos',
      showFilesModal: {
        title: 'Documentos subidos',
        error: 'Error al cargar los documentos'
      }
    }
  },
  transaction: {
    secureTransaction: 'Transacción segura'
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe',
    amazonPayRequired:
      'Después de hacer Login con tu cuenta Amazon, selecciona el método de pago y a continuación la casilla de consentimiento.',
    eIdRequired: 'Es necesario realizar la identificación electrónica.',
    noOptionsTown: 'No encontramos tu Localidad, por favor comprueba tu Código postal.',
    paymentOptionsEmpty:
      'No puede continuar el proceso porque la carga de métodos de pago no ha sido correcta, inténtelo más tarde por favor.'
  },
  success: {}
};
